<template>
  <div class="Facilities">
    <div
      class="mobile-show"
      style="
      width: 100vw;
      height: calc(100vw * 0.125);
      position:absolute;
      top:0;
      background: url(./img/mobile_header_bg1.jpg) center top  / cover;
      background-repeat: no-repeat;
      "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/facilities_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/facilities_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/facilities_slide03.jpg') center center / cover;"
        ></div>
      </agile>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/facilities_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div style="position:absolute;top:0;">
        <agile
          id="word-agile"
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:600px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_diligent.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_reliable.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;">
            <div class="slide-overlay">
              <img src="img/chinese_precision.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>
    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;padding-top:40px;padding-bottom:30px;"
      >
        <span class="title-size">{{$t('body.facilities_productionplants_title')}}</span>
        <div class="subtitlebodyblue" style="margin-bottom:30px;">{{$t('body.facilitiesp1')}}</div>
        <div class="subtitlebodyblue">{{$t('body.facilitiesp2')}}</div>
      </div>
                    <div
        v-if="this.$i18n.locale == 'cn'"
        class="container middle-separator line-bottom-right-120 mobile-hide">
        EXPLORE
      </div>
      <div
        v-if="this.$i18n.locale == 'en'"
        class="container middle-separator line-bottom-right mobile-hide">
        <img style="position: relative; top: 6px;" src="img/chinese_explore.jpg" alt width="60" />
      </div>


      <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <parallax
            class="mobile-hide"
            :imagelink="'./img/facilities_parallax02.jpg'"
            :pspeed="1"
            :containerheight="'350px'"
          ></parallax>
          <div
            class="mobile-show"
            style="
          width:100%;
          height:200px;
          background:url('./img/facilities_parallax02.jpg') center 0 / cover;
          "
          ></div>
        </u-animate>
      </u-animate-container>

      <!-- 2 paragraphs -->
      <div class="container mobile-padding" style="text-align:left;">
        <div class="mobile-show" style="padding-top:32px;"></div>
        <div class="mobile-hide" style="padding-top:12px;"></div>
        <div class="columns" style="padding:16px 0 8px;">
          <div
            class="column subtitle text-left"
            style="padding-bottom:0;font-family:AvenirBold;"
          >{{$t('body.facilitiest2')}}</div>
        </div>

        <div class="columns bodygrey">
          <div class="column mobile-column-padding-right mobile-column-padding-bottom text-left">
            <div>{{$t('body.facilitiesp4')}}</div>
          </div>
          <div class="column text-left">
            <div>
              <span class="bodyblue">{{$t('body.facilitiesp4_1')}}</span>
              <span>{{$t('body.facilitiesp4_2')}}</span>
            </div>
            <div class="bodyblue" style="margin-bottom:16px;" @click="topFunction();">
              <router-link :to="'contactdetails'" class="bodyblue">{{$t('body.facilitiesp4_3')}}</router-link>
            </div>
            <div>
              <span class="bodyblue">{{$t('body.facilitiesp3_4')}}</span>
              <span>{{$t('body.facilitiesp4_5')}}</span>
              <span class="bodyblue">{{$t('body.facilitiesp3_6')}}</span>
              <span>{{$t('body.facilitiesp4_7')}}</span>
            </div>
          </div>
        </div>
        <div class="mobile-show" style="padding-bottom:30px;"></div>
      </div>

                    <div
        v-if="this.$i18n.locale == 'cn'"
        class="container middle-separator line-bottom-right-100 mobile-hide">
        RESULT
      </div>
      <div
        v-if="this.$i18n.locale == 'en'"
        class="container middle-separator line-bottom-right mobile-hide">
        <img style="position: relative; top: 6px;" src="img/chinese_result.jpg" alt width="60" />
      </div>


      <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <parallax
            class="mobile-hide"
            :imagelink="'./img/facilities_parallax01.jpg'"
            :pspeed="1.5"
            :containerheight="'350px'"
          ></parallax>
          <div
            class="mobile-show"
            style="
          width:100%;
          height:200px;
          background:url('./img/facilities_parallax01.jpg') center center / cover;
          "
          ></div>
        </u-animate>
      </u-animate-container>
      <div class="container mobile-padding" style="text-align:left;">
        <div class="mobile-show" style="padding-bottom:30px;"></div>
        <div class="mobile-hide" style="padding-bottom:16px;"></div>
        <div class="columns" style="padding:16px 0;">
          <div
            class="column subtitle text-left"
            style="padding-bottom:0;font-family:AvenirBold;"
          >{{$t('body.facilitiest1')}}</div>
        </div>
        <div class="columns bodygrey">
          <div class="column mobile-column-padding-right mobile-column-padding-bottom text-left">
            <div>{{$t('body.facilitiesp3')}}</div>
          </div>
          <div class="column text-left">
            <div>
              <span class="bodyblue">{{$t('body.facilitiesp3_1')}}</span>
              <span>{{$t('body.facilitiesp3_2')}}</span>
              <!-- <span class="bodyblue">{{$t('body.facilitiesp3_3')}}</span> -->
            </div>
            <div style="margin-bottom:16px;" @click="topFunction();">
              <router-link :to="'contactdetails'" class="bodyblue">{{$t('body.facilitiesp3_3')}}</router-link>
            </div>
            <div>
              <span class="bodyblue">{{$t('body.facilitiesp3_4')}}</span>
              <span>{{$t('body.facilitiesp3_5')}}</span>
              <span class="bodyblue">{{$t('body.facilitiesp3_6')}}</span>
              <span>{{$t('body.facilitiesp3_7')}}</span>
            </div>
          </div>
        </div>
        <div class="mobile-show" style="padding-bottom:30px;"></div>
      </div>
    </div>
    <div style="position:relative;top:200px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventbus";
// @ is an alias to /src
export default {
  name: "about",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    },
    topFunction() {
      console.log("facilities: top function");
      // $("html, body").animate({ scrollTop: 0 }, 400);
      EventBus.$emit("topFunction");
    }
  }
};
</script>

<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}
#word-agile div div div div.slide {
  width: 100%;
  height: 600px;
  // background: url("../assets/logo.png");
}

.slidetext {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}
.slide-overlay {
  height: 500px;
  font-size: 40px;
  line-height: 1;
  text-align: left;
  color: white;
  border-left: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 60px;
  left: 60px;
}

.slide-overlay::before {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-left: 4px;
  top: 0;
  left: 0;
}
</style>
